import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursService {
  private readonly workingHoursByDay: { [dayOfWeek: number]: [startHour: number, endHour: number] } = {
    [1]: [8, 17],
    [2]: [8, 17],
    [3]: [8, 17],
    [4]: [8, 17],
    [5]: [8, 17],
  };

  public isWorkingHours(date: Date = new Date()): boolean {
    const [startHour, endHour] = this.workingHoursByDay[date.getDay()] || [];
    return startHour !== undefined && date.getHours() >= startHour && date.getHours() < endHour;
  }
}
